export default __webpack_public_path__ + "static/media/keyImg.4a57d173.png";